import {icon} from './icons.mjs';
import {t} from './i18n.mjs';
// One floating message at the top centre, styled like the live badge. info and warn leave after
// AUTO_MS; error stays until tapped/closed or resolved by its key (for example the live connection is back).
// A message that is already showing is not stacked again; it only restarts its timer.
export const LEVELS = ['info', 'warn', 'error'];
export const AUTO_MS = 4000;

export function toaster(el, {timers = globalThis} = {}) {
  let current = null, timer;
  const hide = () => {
    timers.clearTimeout(timer); timer = undefined; current = null;
    el.hidden = true; el.replaceChildren();
  };
  function show(text, level = 'info', key = text) {
    if (!text) return;
    level = LEVELS.includes(level) ? level : 'info';
    // A quieter message never pushes an error aside.
    if (current?.level === 'error' && level !== 'error' && current.key !== key) return;
    const same = current && current.key === key && current.text === text && current.level === level;
    current = {text, level, key};
    timers.clearTimeout(timer); timer = undefined;
    if (!same) {
      el.dataset.level = level;
      // Errors interrupt, everything else waits for a pause.
      el.setAttribute('role', level === 'error' ? 'alert' : 'status');
      el.setAttribute('aria-live', level === 'error' ? 'assertive' : 'polite');
      const body = document.createElement('span'); body.className = 'toast-text'; body.textContent = text;
      const parts = [body];
      if (level === 'error') {
        const close = document.createElement('button');
        close.type = 'button'; close.className = 'toast-close'; close.setAttribute('aria-label', t('toastClose'));
        close.innerHTML = icon('close');
        parts.push(close);
      }
      el.replaceChildren(...parts); el.hidden = false;
    }
    if (level !== 'error') timer = timers.setTimeout(hide, AUTO_MS);
  }
  // Clears the message only if it is still the one for this key.
  const resolve = key => { if (current?.key === key) hide(); };
  el.addEventListener('click', hide);
  return {show, resolve, hide, get current() { return current; }};
}
